import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

import {useIsSaveFraming} from './useIsSaveFraming'

export const MY_LIST_VISIBILITY_EXPERIMENT = 'ea03ef21-my-list-visibility-web'

/**
 * Reading the toggle allocates the user, so a surface passes `isEligible` false
 * where it isn't visible yet or sits outside the test. The brand gate
 * short-circuits the same way.
 */
export const useIsMyListVisibilityOn = (isEligible = true) => {
  const isSaveFraming = useIsSaveFraming()
  const toggle = useToggle()

  return (
    isEligible &&
    isSaveFraming &&
    toggle(MY_LIST_VISIBILITY_EXPERIMENT, false, true)
  )
}
